import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, isRef as _isRef, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6cfd5bc6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex flex-1 flex-col" }

import { ref } from "vue";
import Machine from "./page/Machine.vue";
import WorkingProcedure from "./page/WorkingProcedure.vue";

//定义回调事件

export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  emits: ["switch"],
  setup(__props, { emit }: { emit: ({
  (e: "switch", paget: string, id: number): void;
}), expose: any, slots: any, attrs: any }) {



// ---------------------数据变量定义-------------------------
//变量定义
let activeKey = ref("2");

// ---------------------方法定义-------------------------
const onSelectOrder = (item: number) => {
  //查询订单
  emit("switch", "machine", item)
};

return (_ctx: any,_cache: any) => {
  const _component_a_tab_pane = _resolveComponent("a-tab-pane")!
  const _component_a_tabs = _resolveComponent("a-tabs")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_a_tabs, {
      activeKey: _unref(activeKey),
      "onUpdate:activeKey": _cache[0] || (_cache[0] = ($event: any) => (_isRef(activeKey) ? (activeKey).value = $event : activeKey = $event)),
      style: {"color":"rgba(94, 94, 94, 1)"}
    }, {
      default: _withCtx(() => [
        _createVNode(_component_a_tab_pane, {
          key: "1",
          tab: "工序单"
        }),
        _createVNode(_component_a_tab_pane, {
          key: "2",
          tab: "机台单",
          "force-render": ""
        })
      ]),
      _: 1
    }, 8, ["activeKey"]),
    (_unref(activeKey) === '1')
      ? (_openBlock(), _createBlock(WorkingProcedure, {
          key: 0,
          onSelectOrder: onSelectOrder
        }))
      : _createCommentVNode("", true),
    (_unref(activeKey) === '2')
      ? (_openBlock(), _createBlock(Machine, {
          key: 1,
          onSelectOrder: onSelectOrder
        }))
      : _createCommentVNode("", true)
  ]))
}
}

})